import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!getToken()) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setToken("");
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (pin) => {
    const { data } = await api.post("/auth/login", { pin });
    if (data.access_token) setToken(data.access_token);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch {
      setUser(data);
    }
    return data;
  };

  const register = async (phone, name, pin) => {
    const { data } = await api.post("/auth/register", { phone, name, pin });
    if (data.access_token) setToken(data.access_token);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch {
      setUser(data);
    }
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("[auth] logout request failed:", err);
    }
    setToken("");
    setUser(false);
  };

  const value = useMemo(
    () => ({ user, loading, login, register, logout }),
    [user, loading],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
